import {ParkingReservationState, ParkingsState} from './types';
import {parkingReservationsAdapter} from './adapters';

export const getInitialState = (): ParkingReservationState => ({
  parkingReservations: <ParkingsState>parkingReservationsAdapter.getInitialState(),
  isLoadingParkingReservations: false,
  isReservingParkingSpot: false,
  isLoadingParkingCount: false,
  parkingCountPerNodeOnDate: {},
  isRemovingParkingSpot: false,
});
